import VueViewer from 'v-viewer';
import 'viewerjs/dist/viewer.css';
import Vue from 'vue';
import VuetifyDialog from 'vuetify-dialog';
import * as VueGoogleMaps from 'vue2-google-maps';
import VuetifyGoogleAutocomplete from 'vuetify-google-autocomplete';
import Inputmask from 'inputmask';
import App from './App.vue';
import router from './router';
import store from './store';
import DateAndTime from './components/Common/DateAndTime.vue';
import vuetify from './plugins/vuetify';
import * as strings from './assets/strings';
import './styles/global.scss';
import * as services from './providers/services';
import keys from '../keys';

import PhoneNumberInput from './components/Common/PhoneNumberInput.vue';
import PhoneNumberFormat from './components/Common/PhoneNumberFormat.vue';
import CommonTextInput from './components/Common/CommonTextInput.vue';
import CommonTimePicker from './components/Common/CommonTimePicker.vue';
import CommonAutocompleteInput from './components/Common/CommonAutocompleteInput.vue';
import CommonDateInput from './components/Common/CommonDateInput.vue';
import DialogViewImage from './components/Common/DialogViewImage.vue';
import DialogTermsConditions from './components/Common/DialogTermsConditions.vue';
import DialogViewPdf from './components/Common/DialogViewPdf.vue';
import UploadLegend from './components/Common/UploadLegend.vue';
import CommonTable from './components/Common/CommonTable.vue';
import CommonAutoCompleteItems from './components/Common/CommonAutoCompleteItems.vue';
import CommonTextFieldCurrency from './components/Common/CommonTextFieldCurrency.vue';
import CommonError from './components/Common/CommonError.vue';
import ViewerImage from './components/Common/ViewerImage.vue';
import DontHavePermissionPage from './components/Common/DontHavePermissionPage.vue';

import 'vuetify-dialog/dist/vuetify-dialog.css';

Vue.directive('mask', {
  bind(el, binding) {
    Inputmask.extendAliases({
      'custom-phone': {
        regex: String.raw`^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$`,
        keepStatic: false,
        greedy: false,
      },
    });
    Inputmask.extendAliases({
      'idr-currency': {
        placeholder: '',
        allowPlus: false,
        allowMinus: false,
        regex: '[0]([1-9]{1})?|(\\d*[.]?\\d)*',
      },
    });
    Inputmask.extendAliases({
      idr: {
        placeholder: '',
        allowPlus: false,
        allowMinus: false,
        regex: '^[0][1-9]|[1-9]\\d{0,2}(,\\d{3})*(\\.\\d\\d)?$',
      },
    });
    Inputmask.extendAliases({
      'custom-decimal': {
        placeholder: '',
        allowPlus: false,
        allowMinus: false,
        regex: '^\\d+\\,?\\d*$',
      },
    });
    Inputmask.extendAliases({
      time: {
        placeholder: '',
        regex: '^([0-1][0-9]?|[2][0-3]?|[0-9]):([0-5]?[0-9])?$',
      },
    });
    Inputmask.extendAliases({
      'max-length-255-characters': {
        placeholder: '',
        allowPlus: false,
        allowMinus: false,
        regex: '^.{1,255}$',
      },
    });
    Inputmask.extendAliases({
      'no-special-characters-allowed': {
        placeholder: '',
        allowPlus: false,
        allowMinus: false,
        regex: '[A-Za-z0-9\n\\s]{1,255}',
      },
    });
    Inputmask.extendAliases({
      'no-special-characters-allowed-for-location-name': {
        placeholder: '',
        allowPlus: false,
        allowMinus: false,
        regex: '[A-Za-z0-9()\\-\n\\s]{1,255}',
      },
    });
    Inputmask.extendAliases({
      'custom-integer': {
        allowPlus: false,
        allowMinus: false,
        regex: '0|([1-9])|([1-9]\\d+)',
      },
    });
    Inputmask.extendAliases({
      alphabetic: {
        placeholder: '',
        allowPlus: false,
        allowMinus: false,
        regex: '[A-Za-z\\s]{1,255}',
      },
    });
    Inputmask(binding.value).mask(el.getElementsByTagName('INPUT')[0]);
  },

});
Vue.use(VuetifyDialog, {
  context: {
    vuetify,
  },
});

Vue.use(VueGoogleMaps, {
  load: {
    key: keys().googleMapsApiKey,
    libraries: 'places',
    region: 'id',
    language: 'id',
  },
});
Vue.use(VuetifyGoogleAutocomplete, {
  /*
    not used as loaded with component
    apiKey: key,
  */
  vueGoogleMapsCompatibility: true,
});

Vue.use(VueViewer);
Vue.config.productionTip = false;

Vue.prototype.$_strings = strings;
Vue.prototype.$_services = services;
Vue.prototype.$_item_per_page = [5, 10, 25, 50, 100];

Vue.component('DateAndTime', DateAndTime);
Vue.component('PhoneNumberInput', PhoneNumberInput);
Vue.component('PhoneNumberFormat', PhoneNumberFormat);
Vue.component('CommonTextInput', CommonTextInput);
Vue.component('CommonTimePicker', CommonTimePicker);
Vue.component('CommonAutocompleteInput', CommonAutocompleteInput);
Vue.component('CommonDateInput', CommonDateInput);
Vue.component('DialogViewImage', DialogViewImage);
Vue.component('DialogTermsConditions', DialogTermsConditions);
Vue.component('DialogViewPdf', DialogViewPdf);
Vue.component('UploadLegend', UploadLegend);
Vue.component('CommonTable', CommonTable);
Vue.component('CommonError', CommonError);
Vue.component('CommonAutoCompleteItems', CommonAutoCompleteItems);
Vue.component('CommonTextFieldCurrency', CommonTextFieldCurrency);
Vue.component('DontHavePermissionPage', DontHavePermissionPage);
Vue.component('ViewerImage', ViewerImage);
Vue.mixin({
  computed: {
    userAccess() {
      // if (process.env.VUE_APP_API_TARGET === 'development') {
      //   return {
      //     canCreate: true,
      //     canUpdate: true,
      //     canDelete: true,
      //   };
      // }
      return store.getters['user/userAccess'] || {};
    },
    menuFunctions() {
      return store.getters['user/menuFunctions'] || {};
    },
  },
  methods: {
    capitalizeFirstLetter: (str) => str.charAt(0).toUpperCase() + str.slice(1),
    isEmailValid: (value) => /^[^<>()[\]\\,;:\\%#^\s@\\"$&!@]+@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z0-9_-]+\.)+[a-zA-Z]{2,}))$/.test(value),
    isPhoneNumberValid: (value) => /^(\+62)\s[1-9]{1}\d{2}(?=.{6,14}$)(-\d{4})+(?:-\d{1,4})$/.test(value),
  },
});

if (process.env.VUE_APP_API_TARGET === 'production') {
  console.log = () => { };
}

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount('#app');
